module.exports = __webpack_public_path__ + "img/map_quartiere_commerciale.778ff019.png";